const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function digitsOnly(value: string, maxLength: number): string {
  return value.replace(/\D/g, '').slice(0, maxLength);
}

export function isValidRegistrationEmail(value: string): boolean {
  return EMAIL_PATTERN.test(value.trim());
}

export function isValidRegistrationPassword(value: string): boolean {
  return value.length >= 8 && /[a-z]/.test(value) && /[A-Z]/.test(value) && /\d/.test(value);
}

export function isValidMobilePhone(value: string): boolean {
  return /^\d{9}$/.test(value);
}

export function isValidPersonalId(value: string): boolean {
  return /^\d{11}$/.test(value);
}

export const registrationFieldOrder = [
  'name',
  'surname',
  'idNumber',
  'phone',
  'email',
  'password',
  'passwordRepeat',
  'agree',
] as const;

export type RegistrationField = (typeof registrationFieldOrder)[number];
export type RegistrationValues = Record<Exclude<RegistrationField, 'agree'>, string> & {
  agree: boolean;
};

export function registrationErrors(
  values: RegistrationValues,
  t: (key: string) => string,
): Partial<Record<RegistrationField, string>> {
  const errors: Partial<Record<RegistrationField, string>> = {};
  if (values.name.trim().length < 3) errors.name = t('nameRequirement');
  if (values.surname.trim().length < 3) errors.surname = t('surnameRequirement');
  if (!isValidPersonalId(values.idNumber)) errors.idNumber = t('personalIdInvalid');
  if (!isValidMobilePhone(values.phone)) errors.phone = t('phoneInvalid');
  if (!isValidRegistrationEmail(values.email)) errors.email = t('emailInvalid');
  if (!isValidRegistrationPassword(values.password)) {
    errors.password = t('passwordRequirement');
  }
  if (!values.passwordRepeat) {
    errors.passwordRepeat = t('passwordRepeatRequired');
  } else if (values.passwordRepeat !== values.password) {
    errors.passwordRepeat = t('passwordsMismatch');
  }
  if (!values.agree) errors.agree = t('mustAgree');
  return errors;
}
